<template>
  <v-container fluid class="tour-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-tour`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-island</v-icon>
            Tour
          </v-tab>
          <v-tab
            :href="`#tab-options`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-shape-plus</v-icon>
            Options
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-images`"
          >
            <v-icon class="mr-3">mdi-image-multiple</v-icon>
            Images
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-variations`"
          >
            <v-icon class="mr-3">mdi-format-list-bulleted-type</v-icon>
            Variations
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-prices`"
          >
            <v-icon class="mr-3">mdi-currency-usd</v-icon>
            Prices
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-plans`"
          >
            <v-icon class="mr-3">mdi-archive-clock-outline</v-icon>
            Plan
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-details`"
          >
            <v-icon class="mr-3">mdi-archive-check-outline</v-icon>
            Details
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-seasons`"
          >
            <v-icon class="mr-3">mdi-clock-outline</v-icon>
            Seasons
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-addons`"
          >
            <v-icon class="mr-3">mdi-table-plus</v-icon>
            Add-ons
          </v-tab>
          <v-tab-item
            :value="'tab-tour'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="9" sm="12">
                    <p class="text-h5">Edit Tour</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <v-select
                        class="mb-4"
                        :items="tourtypes"
                        :value="initvalue.tourtype"
                        outlined
                        dense
                        v-on:change="onChangeTour($event, 'tourtype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the type">
                      </v-select>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeTour($event, 'tourcode')"
                        v-bind:value="initvalue.tourcode"
                        placeholder="Tour Code"
                        persistent-hint
                        single-line hint="Enter the tour code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeTour($event, 'tourname')"
                        v-bind:value="initvalue.tourname"
                        placeholder="Tour Name"
                        persistent-hint
                        single-line hint="Enter the tour name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Review', 'Active', 'Inactive']"
                        :value="initvalue.tourstatus"
                        outlined
                        dense
                        v-on:change="onChangeTour($event, 'tourstatus')"
                        placeholder="Status"
                        persistent-hint
                        single-line hint="Please choose the satus">
                      </v-select>
                      <!-- <v-switch
                          color="primary"
                          v-on:change="onChangeTour($event, 'tourstatus')"
                          v-model="edit_tour.tourstatus"
                          v-bind:label="edit_tour.tourstatus"
                          v-bind:value="initvalue.tourstatus"
                          true-value="Active"
                          false-value="Inactive"
                      ></v-switch> -->
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <v-select
                        class="mb-4"
                        :items="vendors.map(x => {
                            return {text: x.vendorname, value: x._id};
                          })"
                        :value="initvalue.vendorid"
                        outlined
                        dense
                        v-on:change="onChangeTour($event, 'vendorid')"
                        placeholder="Vendor"
                        persistent-hint
                        single-line hint="Please choose the vendor">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="countries.map(x => {
                            return {text: x.countryname, value: x._id};
                          })"
                        :value="initvalue.countryid"
                        outlined
                        dense
                        v-on:change="onChangeTour($event, 'countryid')"
                        placeholder="Country"
                        persistent-hint
                        single-line hint="Please choose the country">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="cities.map(x => {
                            return {text: x.cityname, value: x._id};
                          })"
                        :value="initvalue.cityid"
                        outlined
                        dense
                        v-on:change="onChangeTour($event, 'cityid')"
                        placeholder="City"
                        persistent-hint
                        single-line hint="Please choose the city">
                      </v-select>
                      <v-row no-gutters>
                        <v-col cols="12" md="5">
                          <v-text-field
                            type="number"
                            class="mb-4"
                            outlined
                            dense
                            v-on:change="onChangeTour($event, 'tourdays')"
                            v-bind:value="initvalue.tourdays"
                            placeholder="Tour Days"
                            persistent-hint
                            single-line hint="Num of days">
                          </v-text-field>
                        </v-col>
                        <div style="width: 15px;"></div>
                        <v-col cols="12" md="5">
                          <v-text-field
                            type="number"
                            class="mb-4"
                            outlined
                            dense
                            v-on:change="onChangeTour($event, 'tournights')"
                            v-bind:value="initvalue.tournights"
                            placeholder="Tour Nights"
                            persistent-hint
                            single-line hint="Num of nights">
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3" sm="6">
                    <v-form>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeTour($event, 'tourtitle')"
                        v-bind:value="initvalue.tourtitle"
                        placeholder="Tour Title"
                        persistent-hint
                        single-line hint="Please enter the tour title">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeTour($event, 'toursubtitle')"
                        v-bind:value="initvalue.toursubtitle"
                        placeholder="Tour Subtitle"
                        persistent-hint
                        single-line hint="Please enter the tour subtitle">
                      </v-text-field>
                      <v-textarea
                        v-bind:value="initvalue.tourdesc"
                        v-on:change="onChangeTour($event, 'tourdesc')"
                        outlined
                        rows=3
                        label="Description"
                        hint="Please enter the tour description"
                      ></v-textarea>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeTour($event, 'tourkeyword')"
                        v-bind:value="initvalue.tourkeyword"
                        placeholder="Keywords"
                        persistent-hint
                        single-line hint="Enter the keywords">
                      </v-text-field>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12" sm="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/tour/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editTourRequest()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
            :value="'tab-options'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6" sm="12">
                    <p class="text-h5">Edit Options</p>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="3" sm="12">
                    <v-form>
                      <v-text-field
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        v-on:change="onChangeOptions($event, 'markupPercentage')"
                        v-bind:value="edit_options.markupPercentage"
                        placeholder="Markup Percentage"
                        persistent-hint
                        single-line hint="Enter the markup percentage">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        v-on:change="onChangeOptions($event, 'markupValue')"
                        v-bind:value="edit_options.markupValue"
                        placeholder="Markup Value"
                        persistent-hint
                        single-line hint="Enter the markup value">
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3" sm="12">
                    <v-form>
                      <v-select
                          class="mb-4"
                          :items="numofvariations"
                          v-model="numofvariation"
                          v-bind:value="edit_options.numofvariations"
                          v-bind:error="errorindex == 6"
                          v-on:change="onChangeOptions($event, 'numofvariations'); checkVariation()"
                          outlined
                          dense
                          placeholder="Num of Variations"
                          persistent-hint
                          single-line hint="Enter number of variations">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="variationtypes"
                          v-model="variationtype1"
                          v-bind:value="edit_options.variationtype1"
                          v-bind:error="errorindex == 7"
                          v-on:change="onChangeOptions($event, 'variationtype1', true)"
                          v-show="[1,2,3,4,5].includes(numofvariation)" 
                          outlined
                          dense
                          placeholder="First Variation"
                          persistent-hint
                          single-line hint="Select first variation">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="variationtypes"
                          v-model="variationtype2"
                          v-bind:value="edit_options.variationtype2"
                          v-bind:error="errorindex == 8"
                          v-on:change="onChangeOptions($event, 'variationtype2', true)"
                          v-show="[2,3,4,5].includes(numofvariation)"
                          outlined
                          dense
                          placeholder="Second Variation"
                          persistent-hint
                          single-line hint="Select second variation">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="variationtypes"
                          v-model="variationtype3"
                          v-bind:value="edit_options.variationtype3"
                          v-bind:error="errorindex == 9"
                          v-on:change="onChangeOptions($event, 'variationtype3', true)"
                          v-show="numofvariation=='3' || numofvariation=='4' || numofvariation=='5'"
                          outlined
                          dense
                          placeholder="Third Variation"
                          persistent-hint
                          single-line hint="Select third variation">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="variationtypes"
                          v-model="variationtype4"
                          v-bind:value="edit_options.variationtype4"
                          v-bind:error="errorindex == 10"
                          v-on:change="onChangeOptions($event, 'variationtype4')"
                          v-show="numofvariation=='4' || numofvariation=='5'"
                          outlined
                          dense
                          placeholder="Fourth Variation"
                          persistent-hint
                          single-line hint="Select fourth variation">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="variationtypes"
                          v-model="variationtype5"
                          v-bind:value="edit_options.variationtype5"
                          v-bind:error="errorindex == 10"
                          v-on:change="onChangeOptions($event, 'variationtype5')"
                          v-show="numofvariation=='5'"
                          outlined
                          dense
                          placeholder="Fifth Variation"
                          persistent-hint
                          single-line hint="Select fifth variation">
                        </v-select>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="6" sm="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/tour/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editTourOptionsRequest()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onChangePhoto" accept="image/*" />
                        <a :href="initvalue.tourimage"><v-img contain max-height="150" max-width="250" :src="imageurl" /></a>
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/tour/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editTourPhotoRequest()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-images'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                        <v-col md="8">
                          <p class="text-h5">Images</p>
                        </v-col>
                        <v-col md="4" align="right">
                          <v-btn
                            class="button-shadow mr-1"
                            color="secondary"
                            @click="isAddImage = true"
                          >
                            Add
                          </v-btn>
                          <v-btn
                            class="button-shadow mr-1"
                            color="primary"
                            to="/tour/list"
                            replace
                          >
                            Done
                          </v-btn>
                        </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="imageHeaders"
                        :items="images"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteImage" width="500">
                            <v-card>
                              <v-card-title> Delete this Image? </v-card-title>
                              <v-card-text>
                                {{ delete_image.imagename }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteImage = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteImage(delete_image)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.imagetype="{ item }">
                            <a v-if="item.imagetype=='jpg'" :href="item.imageurl" style="text-decoration: none !important;">
                              <v-icon 
                            size="50"
                            color="primary"
                            >
                              mdi-image-outline
                            </v-icon></a>    
                        </template>
                        <template v-slot:item.imagesize="{ item }">
                            {{ (item.imagesize/1000).toFixed(0) + " KB"  }}    
                        </template>
                        <template v-slot:item.createdAt="{ item }">
                          {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}
                        </template>
                        <template v-slot:item.actions="{ item }">

                          <v-btn
                            icon
                            color="primary"
                            @click="deleteImageDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>

                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-variations'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="8" sm="6">
                        <p class="text-h5">Variations</p>
                      </v-col>
                      <v-col md="4" align="right">
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddVariation=true; add_variation={index1: 1, index2: 2, index3: 3, index4: 4, index5: 5}"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-1"
                          color="primary"
                          to="/tour/list"
                          replace
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="variationHeaders"
                        :items="tourvariations"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteVariation" width="500">
                            <v-card>
                              <v-card-title> Delete this Variation? </v-card-title>
                              <v-card-text>
                                {{ delete_variation.variationname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteVariation = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTourVariation(delete_variation)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.options1="{ item }">
                          {{ item.options[0]['value']}}: {{ item.options[0]['desc']}}
                        </template>
                        <template v-slot:item.options2="{ item }">
                          {{ item.options[1]['value']}}: {{ item.options[1]['desc']}}
                        </template>
                        <template v-slot:item.options3="{ item }">
                          {{ item.options[2]['value']}}: {{ item.options[2]['desc']}}
                        </template>
                        <template v-slot:item.options4="{ item }">
                          {{ item.options[3]['value']}}: {{ item.options[3]['desc']}}
                        </template>
                        <template v-slot:item.options5="{ item }">
                          {{ item.options[4]['value']}}: {{ item.options[4]['desc']}}
                        </template>
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editTourVariationDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteTourVariationDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-prices'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="8">
                        <p class="text-h5">Prices</p>
                      </v-col>
                      <v-col md="4" align="right">
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddPrice=true; add_numofprices=[1], add_price={}"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-1"
                          color="primary"
                          to="/tour/list"
                          replace
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        item-key="_id"
                        :headers="header_price"
                        :items="tourprices"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeletePrice" width="500">
                            <v-card>
                              <v-card-title> Delete this Price? </v-card-title>
                              <v-card-text>
                                {{ delete_price.pricename }} - {{ delete_price.variationid!=null ? getVariationOptions(delete_price.variationid) : ''  }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeletePrice = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTourPrice(delete_price)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.createdAt="{ item }">
                          <div style="height: 100%; padding-top: 10px;">
                            <p class="two-line">
                              {{
                                new Date(item.createdAt).toLocaleString("en-SG", {
                                  year: "numeric",
                                  month: "numeric",
                                  day: "numeric",
                                })
                              }}
                            </p>
                          </div>

                        </template>
                        <template v-slot:item.adult_options="{ item }">
                          <div style="height: 100%; vertical-align: top;"><p v-for="(price,index) in getPriceOptions(item.adult_options)" v-bind:key="index" class="two-line" style="font-size: 10pt;">{{ price }}</p></div>
                        </template>
                        <template v-slot:item.youth_options="{ item }">
                          <div style="height: 100%; vertical-align: top;"><p v-for="(price,index) in getPriceOptions(item.youth_options)" v-bind:key="index" class="two-line" style="font-size: 10pt;">{{ price }}</p></div>
                        </template>
                        <template v-slot:item.child_options="{ item }">
                          <div style="height: 100%; vertical-align: top;"><p v-for="(price,index) in getPriceOptions(item.child_options)" v-bind:key="index" class="two-line" style="font-size: 10pt;">{{ price }}</p></div>
                        </template>
                        <template v-slot:item.infant_options="{ item }">
                          <div style="height: 100%; vertical-align: top;"><p v-for="(price,index) in getPriceOptions(item.infant_options)" v-bind:key="index" class="two-line" style="font-size: 10pt;">{{ price }}</p></div>
                        </template>
                        <template v-slot:item.variationid="{ item }">
                          <div style="height: 100%; padding-top: 10px;">
                            <p class="two-line">{{ item.pricename }}</p>
                            <p class="two-line">{{ getVariationOptions(item.variationid) }}</p>
                          </div>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <div style="height: 100%; padding-top: 0px;">
                            <v-btn
                              icon
                              color="primary"
                              @click="editTourPriceDialog(item)"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              color="primary"
                              @click="deleteTourPriceDialog(item)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </div>

                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-plans'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="8">
                        <p class="text-h5">Tour Plans</p>
                      </v-col>
                      <v-col md="4" align="right">
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddPlan=true; add_plan={}"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-1"
                          color="primary"
                          to="/tour/list"
                          replace
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="header_plan"
                        :items="tourplans"
                        :items-per-page="100"
                        sort-by="planrank"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeletePlan" width="500">
                            <v-card>
                              <v-card-title> Delete this Plan? </v-card-title>
                              <v-card-text>
                                {{ delete_plan.plantitle }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeletePlan = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTourPlan(delete_plan)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.plantitle="{ item }">
                          <p class="two-line"><strong>{{ item.plantitle }}</strong></p>
                          <p class="two-line">{{ item.planlocation  }} ({{ item.planmeal  }})</p>
                          <p class="two-line" v-html="item.planbody"></p>
                        </template>
                        <template v-slot:item.planrank="{ item }">
                          <div style="height: 100%; padding-top: 5px;">
                            {{item.planrank}}
                          </div>
                        </template>  
                        <template v-slot:item.planimage="{ item }">
                          <div style="height: 100%; padding-top: 10px;">
                            <img v-if="item.planimage" v-bind:src="item.planimage" alt="" width="80">
                          </div>
                        </template>                          
                        <template v-slot:item.createdAt="{ item }">
                          <div style="height: 100%; padding-top: 5px;">
                            {{ new Date(item.createdAt).toLocaleString("en-SG", { year: "numeric", month: "numeric", day: "numeric"}) }}
                          </div>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <div style="height: 100%; padding-top: 0px;">
                            <v-btn
                              icon
                              color="primary"
                              @click="editTourPlanDialog(item)"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              color="primary"
                              @click="deleteTourPlanDialog(item)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </div>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-details'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="8">
                        <p class="text-h5">Tour Details</p>
                      </v-col>
                      <v-col md="4" align="right">
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddDetail=true; add_detail={}"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-1"
                          color="primary"
                          to="/tour/list"
                          replace
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="header_detail"
                        :items="tourdetails"
                        :items-per-page="100"
                        sort-by="detailrank"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteDetail" width="500">
                            <v-card>
                              <v-card-title> Delete this Detail? </v-card-title>
                              <v-card-text>
                                {{ delete_detail.detailtitle }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteDetail = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTourDetail(delete_detail)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.detailtitle="{ item }">
                          <p class="two-line"><strong>{{ item.detailtitle   }}</strong></p>
                          <p class="two-line" v-html="item.detailbody"></p>
                        </template>                        
                        <template v-slot:item.detailrank="{ item }">
                          <div style="height: 100%; padding-top: 5px;">
                            {{item.detailrank}}
                          </div>
                        </template>
                        <template v-slot:item.createdAt="{ item }">
                          <div style="height: 100%; padding-top: 5px;">
                            {{ new Date(item.createdAt).toLocaleString("en-SG", { year: "numeric", month: "numeric", day: "numeric" }) }}
                          </div>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <div style="height: 100%; padding-top: 0px;">
                            <v-btn
                              icon
                              color="primary"
                              @click="editTourDetailDialog(item)"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn
                              icon
                              color="primary"
                              @click="deleteTourDetailDialog(item)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </div>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-seasons'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="8">
                        <p class="text-h5">Peak Seasons</p>
                      </v-col>
                      <v-col md="4" align=right>
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddSeason = true"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-1"
                          color="primary"
                          to="/tour/list"
                          replace
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="seasonHeaders"
                        :items="tourseasons"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteSeason" width="500">
                            <v-card>
                              <v-card-title> Delete this Peak Season? </v-card-title>
                              <v-card-text>
                                {{ delete_season.seasonname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteSeason = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTourSeason(delete_season)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.seasonname="{ item }">
                          <p class="two-line"><strong>{{ item.seasonname   }}</strong></p>
                        </template>   
                        <template v-slot:item.seasondays="{ item }">
                          <p class="two-line">{{ item.seasontype  }}</p>
                          <p class="two-line">{{ item.seasondays.join(', ')  }}</p>
                        </template> 
                        <template v-slot:item.variations="{ item }">
                          <p v-for="variation in item.variations" v-bind:key="variation" class="two-line">{{ getVariationsText(variation) }}</p>
                        </template>
                        <template v-slot:item.addons="{ item }">
                          <p v-for="addon in item.addons" v-bind:key="addon" class="two-line">{{ getAddonText(addon) }}</p>
                        </template>  
                        <template v-slot:item.surcharge="{ item }">
                          <p class="two-line">{{ item.surcharge.class  }}</p>
                          <p class="two-line">{{ item.surcharge.value + ' ' +item.surcharge.type  }}</p>
                        </template>                        
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editTourSeasonDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteTourSeasonDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-addons'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="8">
                        <p class="text-h5">Add-ons</p>
                      </v-col>
                      <v-col md="4" align=right>
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddAddon = true"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-1"
                          color="primary"
                          to="/tour/list"
                          replace
                        >
                          Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="header_addon"
                        :items="touraddons"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteAddon" width="500">
                            <v-card>
                              <v-card-title> Delete this Add-on? </v-card-title>
                              <v-card-text>
                                {{ delete_addon.addonname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteAddon = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTourAddon(delete_addon)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.addonname="{ item }">
                          <p class="two-line"><strong>{{ item.addonname   }}</strong></p>
                          <p class="two-line">{{ item.addoninfo   }}</p>
                        </template>
                        <template v-slot:item.variations="{ item }">
                          <p v-for="variation in item.variations" v-bind:key="variation" class="two-line">{{ getVariationsText(variation) }}</p>
                        </template>  
                        <template v-slot:item.options="{ item }">
                          <p class="two-line">{{ item.options.type }}</p>
                          <p class="two-line">{{ item.options.price + ' ' + item.options.currency }}</p>
                        </template>                        
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editTourAddonDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteTourAddonDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  <!-- Dialog Boxes -->
  <v-row justify="center">
    <v-dialog
      v-model="isAddImage"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Upload Image</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
              <v-file-input label="Image input" v-on:change="onImageChange" accept=".jpg" />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="upload_image.imagename"
                  label="Image Name"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddImage = false; upload_image.image=null; upload_image.imagename=''"
          >
            Close
          </v-btn>
          <v-btn
            :disabled="upload_image.image==null && this.upload_image.imagename.length<2"
            color="blue darken-1"
            text
            @click="uploadImage"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isAddVariation"
      persistent
      width="1000px"
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Variation</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <!-- Variation 1 -->
            <v-row v-if="initvalue.options!=null && ([1,2,3,4,5].includes(initvalue.options.numofvariations))">
              <v-col cols="2" class="d-flex align-center">
                <p class="fs-normal greyBold--text mb-0">{{ initvalue.options.variationtype1 }}</p>
              </v-col>
              <v-col cols="12" md="1">
                <v-text-field
                  readonly
                  v-model="add_variation.index1"
                  :value="1"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-if="initvalue.options.variationtype1=='Hotel Rating'"
                  :items="hotelratings"
                  v-model="add_variation.variationtype1"
                  label="Variation"
                  required
                ></v-select>
                <v-text-field
                  v-else
                  v-model="add_variation.variationtype1"
                  label="Variation"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="add_variation.variationdesc1"
                  class="mb-4"
                  placeholder="Desc"
                  single-line
                  hint="Desc"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <!-- Variation 2 -->
            <v-row v-if="initvalue.options!=null && ([2,3,4,5].includes(initvalue.options.numofvariations))">
              <v-col cols="2" class="d-flex align-center">
                <p class="fs-normal greyBold--text mb-0">{{ initvalue.options.variationtype2 }}</p>
              </v-col>
              <v-col cols="12" md="1">
                <v-text-field
                  readonly
                  v-model="add_variation.index2"
                  value="2"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-if="initvalue.options.variationtype2=='Hotel Rating'"
                  :items="hotelratings"
                  v-model="add_variation.variationtype2"
                  label="Variation"
                  required
                ></v-select>
                <v-text-field
                  v-else
                  v-model="add_variation.variationtype2"
                  label="Variation"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="add_variation.variationdesc2"
                  class="mb-4"
                  placeholder="Desc"
                  single-line
                  hint="Desc"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <!-- Variation 3 -->
            <v-row v-if="initvalue.options!=null && ([3,4,5].includes(initvalue.options.numofvariations))">
                <v-col cols="2" class="d-flex align-center">
                  <p class="fs-normal greyBold--text mb-0">{{ initvalue.options.variationtype3 }}</p>
                </v-col>
              <v-col cols="12" md="1">
                <v-text-field
                  readonly
                  v-model="add_variation.index3"
                  value="3"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-if="initvalue.options.variationtype3=='Hotel Rating'"
                  :items="hotelratings"
                  v-model="add_variation.variationtype3"
                  label="Variation"
                  required
                ></v-select>
                <v-text-field
                  v-else
                  v-model="add_variation.variationtype3"
                  label="Variation"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="add_variation.variationdesc3"
                  class="mb-4"
                  placeholder="Desc"
                  single-line
                  hint="Desc"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <!-- Variation 4 -->
            <v-row v-if="initvalue.options!=null && ([4,5].includes(initvalue.options.numofvariations))">
                <v-col cols="2" class="d-flex align-center">
                  <p class="fs-normal greyBold--text mb-0">{{ initvalue.options.variationtype4 }}</p>
                </v-col>
              <v-col cols="12" md="1">
                <v-text-field
                  readonly
                  v-model="add_variation.index4"
                  value="4"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-if="initvalue.options.variationtype4=='Hotel Rating'"
                  :items="hotelratings"
                  v-model="add_variation.variationtype4"
                  label="Variation"
                  required
                ></v-select>
                <v-text-field
                  v-else
                  v-model="add_variation.variationtype4"
                  label="Variation"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="add_variation.variationdesc4"
                  class="mb-4"
                  placeholder="Desc"
                  single-line
                  hint="Desc"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <!-- Variation 5 -->
            <v-row v-if="initvalue.options!=null && ([5].includes(initvalue.options.numofvariations))">
                <v-col cols="2" class="d-flex align-center">
                  <p class="fs-normal greyBold--text mb-0">{{ initvalue.options.variationtype5 }}</p>
                </v-col>
              <v-col cols="12" md="1">
                <v-text-field
                  readonly
                  v-model="add_variation.index5"
                  value="5"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-if="initvalue.options.variationtype5=='Hotel Rating'"
                  :items="hotelratings"
                  v-model="add_variation.variationtype5"
                  label="Variation"
                  required
                ></v-select>
                <v-text-field
                  v-else
                  v-model="add_variation.variationtype5"
                  label="Variation"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="add_variation.variationdesc5"
                  class="mb-4"
                  placeholder="Desc"
                  single-line
                  hint="Desc"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddVariation = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addTourVariation"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="isAddPrice"
      persistent
      width="1000px"
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Price</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row no-gutters>
              <v-col class="mt-2 pr-2" cols="12" md="4">
                <v-select
                  dense
                  :items="getVariationsList()"
                  v-model="add_price.variationid"
                  label="Variation"
                  required
                ></v-select>
              </v-col>
              <v-col class="mt-2 pr-2" cols="12" md="4">
                <v-select
                  dense
                  :items="pricelists.filter(x=>x.pricelisttype=='Sales').map(x => {
                            return {text: x.pricelistname, value: x._id};
                          })"
                  v-model="add_price.pricelistid"
                  label="Price List"
                  required
                ></v-select>
              </v-col>
              <v-col class="mt-2 pr-2" cols="12" md="4">
                <v-text-field
                  dense
                  v-model="add_price.pricename"
                  label="Price Name"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
            <div style="height: 10px;">&nbsp;</div>
            </v-row>
            <v-row v-for="index in add_numofprices" v-bind:key="index" no-gutters>
              <v-col class="pr-2" cols="12" md="2">
                <v-select
                  dense
                  :items="priceclasses"
                  v-model="add_price['class'+ index]"
                  label="Class"
                  required
                ></v-select>
              </v-col>
              <v-col class="pr-2" cols="12" md="2">
                <v-text-field
                  dense
                  v-model="add_price['subclass'+ index]"
                  label="Subclass"
                  required
                ></v-text-field>
              </v-col>
              <v-col class="pr-2" cols="12" md="2">
                <v-text-field
                  dense
                  v-model="add_price['desc'+ index]"
                  label="Description"
                  required
                ></v-text-field>
              </v-col>
                <v-col class="pr-2" cols="12" md="1">
                <v-text-field
                  dense
                  v-model="add_price['minpax'+ index]"
                  class="mb-4"
                  placeholder="Min"
                  type="number"
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Min"
                >
                </v-text-field>
              </v-col>
              <v-col class="pr-2" cols="12" md="1">
                <v-text-field
                  dense
                  v-model="add_price['maxpax'+ index]"
                  class="mb-4"
                  placeholder="Max"
                  type="number"
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Max"
                >
                </v-text-field>
              </v-col>
                <v-col class="pr-2" cols="12" md="2">
                <v-text-field
                  dense
                  v-model="add_price['listprice'+ index]"
                  class="mb-4"
                  placeholder="List Price"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Price"
                >
                </v-text-field>
              </v-col>
              <v-col class="pr-2" cols="12" md="2">
                <v-select
                  dense
                  :items="currencies"
                  v-model="add_price['currency'+ index]"
                  label="Currency"
                  required
                ></v-select>
              </v-col>
            </v-row>
            <v-btn
              class="button-shadow"
              color="secondary"
              @click="add_numofprices.push(add_numofprices.length+1)"
            >
              Add Class
            </v-btn>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddPrice = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addTourPrice"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isAddPlan"
      persistent
      width="900px"
      max-width="900px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Plan</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_plan.planrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="10">
                <v-text-field
                  v-model="add_plan.plantitle"
                  label="Title"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-file-input outlined dense label="File input" v-on:change="onChangeAddPlanFile" accept="image/*" />     
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  dense
                  v-model="add_plan.planlocation"
                  label="Location"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  dense
                  v-model="add_plan.planmeal"
                  label="Meal"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                 <vue-editor v-model="add_plan.planbody"></vue-editor>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddPlan = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addTourPlan"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isAddDetail"
      persistent
      width="900px"
      max-width="900px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Detail</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_detail.detailrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="10">
                <v-text-field
                  v-model="add_detail.detailtitle"
                  label="Title"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                  <vue-editor v-model="add_detail.detailbody"></vue-editor>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddDetail = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addTourDetail"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="isEditVariation"
      persistent
      width="1000px"
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Variation</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <!-- Variation 1 -->
            <v-row v-if="initvalue.options!=null && ([1,2,3,4,5].includes(initvalue.options.numofvariations))">
              <v-col cols="2" class="d-flex align-center">
                <p class="fs-normal greyBold--text mb-0">{{ initvalue.options.variationtype1 }}</p>
              </v-col>
              <v-col cols="12" md="1">
                <v-text-field
                  readonly
                  v-model="edit_variation.index1"
                  :value="1"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-if="initvalue.options.variationtype1=='Hotel Rating'"
                  :items="hotelratings"
                  v-model="edit_variation.variationtype1"
                  label="Variation"
                  required
                ></v-select>
                <v-text-field
                  v-else
                  v-model="edit_variation.variationtype1"
                  label="Variation"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="edit_variation.variationdesc1"
                  class="mb-4"
                  placeholder="Desc"
                  single-line
                  hint="Desc"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <!-- Variation 2 -->
            <v-row v-if="initvalue.options!=null && ([2,3,4,5].includes(initvalue.options.numofvariations))">
              <v-col cols="2" class="d-flex align-center">
                <p class="fs-normal greyBold--text mb-0">{{ initvalue.options.variationtype2 }}</p>
              </v-col>
              <v-col cols="12" md="1">
                <v-text-field
                  readonly
                  v-model="edit_variation.index2"
                  value="2"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-if="initvalue.options.variationtype2=='Hotel Rating'"
                  :items="hotelratings"
                  v-model="edit_variation.variationtype2"
                  label="Variation"
                  required
                ></v-select>
                <v-text-field
                  v-else
                  v-model="edit_variation.variationtype2"
                  label="Variation"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="edit_variation.variationdesc2"
                  class="mb-4"
                  placeholder="Desc"
                  single-line
                  hint="Desc"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <!-- Variation 3 -->
            <v-row v-if="initvalue.options!=null && ([3,4,5].includes(initvalue.options.numofvariations))">
              <v-col cols="2" class="d-flex align-center">
                <p class="fs-normal greyBold--text mb-0">{{ initvalue.options.variationtype3 }}</p>
              </v-col>
              <v-col cols="12" md="1">
                <v-text-field
                  readonly
                  v-model="edit_variation.index3"
                  value="3"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-if="initvalue.options.variationtype3=='Hotel Rating'"
                  :items="hotelratings"
                  v-model="edit_variation.variationtype3"
                  label="Variation"
                  required
                ></v-select>
                <v-text-field
                  v-else
                  v-model="edit_variation.variationtype3"
                  label="Variation"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="edit_variation.variationdesc3"
                  class="mb-4"
                  placeholder="Desc"
                  single-line
                  hint="Desc"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <!-- Variation 4 -->
            <v-row v-if="initvalue.options!=null && ([4,5].includes(initvalue.options.numofvariations))">
              <v-col cols="2" class="d-flex align-center">
                <p class="fs-normal greyBold--text mb-0">{{ initvalue.options.variationtype4 }}</p>
              </v-col>
              <v-col cols="12" md="1">
                <v-text-field
                  readonly
                  v-model="edit_variation.index4"
                  value="4"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-if="initvalue.options.variationtype4=='Hotel Rating'"
                  :items="hotelratings"
                  v-model="edit_variation.variationtype4"
                  label="Variation"
                  required
                ></v-select>
                <v-text-field
                  v-else
                  v-model="edit_variation.variationtype4"
                  label="Variation"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="edit_variation.variationdesc4"
                  class="mb-4"
                  placeholder="Desc"
                  single-line
                  hint="Desc"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <!-- Variation 5 -->
            <v-row v-if="initvalue.options!=null && ([5].includes(initvalue.options.numofvariations))">
                <v-col cols="2" class="d-flex align-center">
                  <p class="fs-normal greyBold--text mb-0">{{ initvalue.options.variationtype5 }}</p>
                </v-col>
              <v-col cols="12" md="1">
                <v-text-field
                  readonly
                  v-model="edit_variation.index5"
                  value="5"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-if="initvalue.options.variationtype5=='Hotel Rating'"
                  :items="hotelratings"
                  v-model="edit_variation.variationtype5"
                  label="Variation"
                  required
                ></v-select>
                <v-text-field
                  v-else
                  v-model="edit_variation.variationtype5"
                  label="Variation"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="edit_variation.variationdesc5"
                  class="mb-4"
                  placeholder="Desc"
                  single-line
                  hint="Desc"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditVariation = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editTourVariation"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="isEditPrice"
      persistent
      width="1000px"
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Price</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row no-gutters>
              <v-col class="mt-2 pr-2" cols="12" md="4">
                <v-select
                  dense
                  :items="getVariationsList()"
                  v-model="edit_price.variationid"
                  label="Variation"
                  required
                ></v-select>
              </v-col>
              <v-col class="mt-2 pr-2" cols="12" md="4">
                <v-select
                  dense
                  :items="pricelists.filter(x=>x.pricelisttype=='Sales').map(x => {
                            return {text: x.pricelistname, value: x._id};
                          })"
                  v-model="edit_price.pricelistid"
                  label="Price List"
                  required
                ></v-select>
              </v-col>
              <v-col class="mt-2 pr-2" cols="12" md="4">
                <v-text-field
                  dense
                  v-model="edit_price.pricename"
                  label="Price Name"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <div style="height: 10px;">&nbsp;</div>
            <v-row v-for="(index, i) in edit_numofprices" v-bind:key="index" no-gutters>
              <v-col class="pr-2" cols="12" md="2">
                <v-select
                  dense
                  :items="priceclasses"
                  v-model="edit_price['class'+ index]"
                  label="Class"
                  required
                ></v-select>
              </v-col>
              <v-col class="pr-2" cols="12" md="2">
                <v-text-field
                  dense
                  v-model="edit_price['subclass'+ index]"
                  label="Subclass"
                  required
                ></v-text-field>
              </v-col>
              <v-col class="pr-2" cols="12" md="2">
                <v-text-field
                  dense
                  v-model="edit_price['desc'+ index]"
                  label="Description"
                  required
                ></v-text-field>
              </v-col>
                <v-col class="pr-2" cols="12" md="1">
                <v-text-field
                  dense 
                  v-model="edit_price['minpax'+ index]"
                  class="mb-4"
                  placeholder="Min"
                  type="number"
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Min"
                >
                </v-text-field>
              </v-col>
              <v-col class="pr-2" cols="12" md="1">
                <v-text-field
                  dense
                  v-model="edit_price['maxpax'+ index]"
                  class="mb-4"
                  placeholder="Max"
                  type="number"
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Max"
                >
                </v-text-field>
              </v-col>
                <v-col class="pr-2" cols="12" md="1">
                <v-text-field
                  dense
                  v-model="edit_price['listprice'+ index]"
                  class="mb-4"
                  placeholder="List Price"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Price"
                >
                </v-text-field>
              </v-col>
              <v-col class="pr-2" cols="12" md="2">
                <v-select
                  dense
                  :items="currencies"
                  v-model="edit_price['currency'+ index]"
                  label="Currency"
                  required
                ></v-select>
              </v-col>
              <v-col class="pr-2" cols="12" md="1" align="right">
                <v-btn
                  icon
                  color="primary"
                  @click="deletePriceOption(i)"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-btn
              class="button-shadow"
              color="secondary"
              @click="edit_numofprices.push(edit_numofprices.length+1)"
            >
              Add Class
            </v-btn>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditPrice = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editTourPriceRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isEditDetail"
      persistent
      width="900px"
      max-width="900px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Detail</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeDetail($event, 'detailrank')"
                  :value="edit_detail.detailrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="10">
                <v-text-field
                  v-on:change="onChangeDetail($event, 'detailtitle')"
                  :value="edit_detail.detailtitle"
                  label="Title"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                  <vue-editor v-model="edit_detail.detailbody" @text-change="onChangeDetail(edit_detail.detailbody, 'detailbody')"></vue-editor>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditDetail = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editTourDetail"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isEditPlan"
      persistent
      width="900px"
      max-width="900px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Plan</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="1">
                <v-text-field
                  v-on:change="onChangePlan($event, 'planrank')"
                  :value="edit_plan.planrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="11">
                <v-text-field
                  v-on:change="onChangePlan($event, 'plantitle')"
                  :value="edit_plan.plantitle"
                  label="Title"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-file-input outlined dense label="File input" v-on:change="onChangeEditPlanFile" accept="image/*" />     
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  dense
                  v-on:change="onChangePlan($event, 'planlocation')"
                  :value="edit_plan.planlocation"
                  label="Location"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  outlined
                  dense
                  v-on:change="onChangePlan($event, 'planmeal')"
                  :value="edit_plan.planmeal"
                  label="Meal"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                 <vue-editor v-model="edit_plan.planbody" @text-change="onChangePlan(edit_plan.planbody, 'planbody')"></vue-editor>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditPlan=false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editTourPlan"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <v-row justify="center">
    <v-dialog
      v-model="isAddAddon"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Add-on</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="addon.addonname"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
              <v-combobox
                v-model="addon.variations"
                :items="getVariationsList()"
                label="Select applicable variations"
                multiple
                chips
              ></v-combobox>
            </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-select
                  :items="addontypes"
                  v-model="addon.options.type"
                  label="Type"
                  required
                ></v-select>
              </v-col>
                <v-col cols="12" md="4">
                <v-text-field
                  v-model="addon.options.price"
                  class="mb-4"
                  placeholder="Price"
                  type="number"
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Price"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  :items="currencies"
                  v-model="addon.options.currency"
                  label="Currency"
                  required
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-textarea
                  v-model="addon.addoninfo"
                  outlined
                  rows=1
                  label="Info"
                  hint="Please enter the add-on info"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddAddon = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addTourAddon"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <v-row justify="center">
    <v-dialog
      v-model="isAddSeason"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Season</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="season.seasonname"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  :items="seasontypes"
                  v-model="season.seasontype"
                  label="Type"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-combobox
                  v-model="season.variations"
                  :items="getVariationsList()"
                  label="Select applicable variations"
                  multiple
                  chips
                ></v-combobox>
                <v-combobox
                  v-model="season.addons"
                  :items="getAddonsList()"
                  label="Select applicable add-ons"
                  multiple
                  chips
                ></v-combobox>
              </v-col>
              <v-col cols="12">
              <v-combobox
                v-show="season.seasontype=='Days of Week'"
                v-model="season.seasondays"
                :items="['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']"
                label="Select days of week"
                multiple
                chips
              ></v-combobox>
            </v-col>
            </v-row>
            <v-row v-show="season.seasontype=='Dates'">
              <v-col
                cols="12"
                md="12"
                sm="12"
              >
                <v-menu
                  ref="menu_seasondates"
                  v-model="menu_seasondates"
                  :close-on-content-click="false"
                  :return-value.sync="season.seasondates"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-combobox
                      v-model="season.seasondates"
                      multiple
                      chips
                      small-chips
                      label="Multiple picker in menu"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-combobox>
                  </template>
                  <v-date-picker
                    v-model="season.seasondates"
                    multiple
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_seasondates = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_seasondates.save(season.seasondates)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col
                cols="12"
                sm="12"
              >
                <v-date-picker
                  v-model="season.seasondates"
                  multiple
                ></v-date-picker>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-select
                  :items="surchargeclasses"
                  v-model="season.surcharge.class"
                  label="Surcharge Class"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  :items="surchargetypes"
                  v-model="season.surcharge.type"
                  label="Surcharge Type"
                  required
                ></v-select>
              </v-col>
                <v-col cols="12" md="4">
                <v-text-field
                  v-model="season.surcharge.value"
                  class="mb-4"
                  placeholder="Surcharge Value"
                  type="number"
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Surcharge Value"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddSeason = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addTourSeason"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isEditSeason"
      persistent
      width="800px"
      max-width="800px"
      >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Season</span>
        </v-card-title>
        <v-card-text>
          
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="season.seasonname"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  :items="seasontypes"
                  v-model="season.seasontype"
                  label="Type"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-combobox
                  v-model="season.variations"
                  :items="getVariationsList()"
                  label="Select applicable variations"
                  multiple
                  chips
                ></v-combobox>
                <v-combobox
                  v-model="season.addons"
                  :items="getAddonsList()"
                  label="Select applicable add-ons"
                  multiple
                  chips
                ></v-combobox>
              </v-col>
              <v-col cols="12">
              <v-combobox
                v-show="season.seasontype=='Days of Week'"
                v-model="season.seasondays"
                :items="['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']"
                label="Select days of week"
                multiple
                chips
              ></v-combobox>
            </v-col>
            </v-row>
            <v-row v-show="season.seasontype=='Dates'">
              <v-col
                cols="12"
                md="12"
                sm="12"
              >
                <v-menu
                  ref="menu_seasondates"
                  v-model="menu_seasondates"
                  :close-on-content-click="false"
                  :return-value.sync="season.seasondates"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-combobox
                      v-model="season.seasondates"
                      multiple
                      chips
                      small-chips
                      label="Multiple picker in menu"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-combobox>
                  </template>
                  <v-date-picker
                    v-model="season.seasondates"
                    multiple
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_seasondates = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_seasondates.save(season.seasondates)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col
                cols="12"
                sm="12"
              >
                <v-date-picker
                  v-model="season.seasondates"
                  multiple
                ></v-date-picker>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-select
                  :items="surchargeclasses"
                  v-model="season.surcharge.class"
                  label="Surcharge Class"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  :items="surchargetypes"
                  v-model="season.surcharge.type"
                  label="Surcharge Type"
                  required
                ></v-select>
              </v-col>
                <v-col cols="12" md="4">
                <v-text-field
                  v-model="season.surcharge.value"
                  class="mb-4"
                  placeholder="Surcharge Value"
                  type="number"
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Surcharge Value"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditSeason = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editTourSeason"
            >
              Save
            </v-btn>
          </v-card-actions>
         
      </v-card>
      </v-dialog>
      <v-dialog
      v-model="isEditAddon"
      persistent
      width="800px"
      max-width="800px"
      >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Add-on</span>
        </v-card-title>
          <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="addon.addonname"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
              <v-combobox
                v-model="addon.variations"
                :items="getVariationsList()"
                label="Select applicable variations"
                multiple
                chips
              ></v-combobox>
            </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-select
                  :items="addontypes"
                  v-model="addon.options.type"
                  label="Type"
                  required
                ></v-select>
              </v-col>
                <v-col cols="12" md="4">
                <v-text-field
                  v-model="addon.options.price"
                  class="mb-4"
                  placeholder="Price"
                  type="number"
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Price"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  :items="currencies"
                  v-model="addon.options.currency"
                  label="Currency"
                  required
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-textarea
                  v-model="addon.addoninfo"
                  outlined
                  rows=1
                  label="Info"
                  hint="Please enter the add-on info"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
          
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditAddon = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editTourAddon"
            >
              Save
            </v-btn>
          </v-card-actions>
      </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>



<script>
import { VueEditor } from "vue2-editor";
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
   components: {
    VueEditor
  },
  data () {
    return {
      header_addon: [
        { text: "Name", value: "addonname", width:"30%"},
        { text: "Variations", value: "variations", width:"40%"},
        { text: "Options", value: "options", width: "10%"},
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      header_detail: [
        { text: "#", value: "detailrank", width: "10px" },
        { text: "Title & Body", value: "detailtitle" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      imageHeaders: [
        { text: "Type", value: "imagetype" },
        { text: "Name", value: "imagename" },
        { text: "Size", value: "imagesize" },
        { text: "Created", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      header_plan: [
        { text: "#", value: "planrank", width: "10px" },
        { text: "Image", value: "planimage", sortable: false, width: "10%"},
        { text: "Title", value: "plantitle" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false, width: "10%" },
      ],
      header_price: [
        { text: "Name", value: "variationid", width: "18%" },
        { text: "Adult", value: "adult_options", width: "18%" },
        { text: "Youth", value: "youth_options", width: "18%" },
        { text: "Child", value: "child_options", width: "18%" },
        { text: "Infant", value: "infant_options", width: "18%" },
        { text: "Actions", value: "actions", sortable: false , width: "5%"},
      ],
      seasonHeaders: [
        { text: "Name", value: "seasonname" , width: "10%"},
        { text: "Variations", value: "variations", width:"30%"},
        { text: "Add-Ons", value: "addons", width:"20%"},
        { text: "Dates", value: "seasondays" , width:"20%"},
        { text: "Surcharge", value: "surcharge" , width: "10%"},
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      variationHeaders: [
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      priceclasses: ["Adult", "Youth", "Child", "Infant"],
      addontypes: ["Fixed", "Per Adult", "Per Child", "Per Infant", "Per Person", "Per Night"],
      surchargeclasses: ["Fixed", "Per Adult", "Per Child", "Per Infant", "Per Person"],
      seasontypes: ["Days of Week", "Dates"],
      surchargetypes: ["Amount", "Percentage"],
      currencies: ["SGD", "USD"],
      tourtypes: ["Group Tour" , "Private Tour", "Free & Easy"],
      hotelratings: ["2-Star" , "3-Star", "4-Star", "5-Star"],
      numofvariations: [1,2,3,4,5],
      variationtypes: ["Bed Type", "Day Type", "Hotel Name", "Hotel Rating", "Hotel Type", "Meal Type", "Room Type", "Stay Length", "Tour Type", "Transfer Type"],
      touraddons: [],
      tourdetails: [],
      tourprices: [],
      tourplans: [],
      tourseasons: [],
      tourvariations: [],
      images: [],
      add_numofprices: [1],
      edit_numofprices: [1],

      fileplan: null,
      filename: null,
      imageurl: undefined,
      numofvariation: null,
      variationtype0: null,
      variationtype1: null,
      variationtype2: null,
      variationtype3: null,
      variationtype4: null,
      variationtype5: null,

      initvalue: {},
      change_photo: {},
      
      addon: {options: {}},
      detail: {},
      plan: {},
      price: {},
      season: {surcharge: {},seasondates: [],},
      
      add_detail: {},
      add_plan: {},
      add_price: {},
      add_variation: {},

      change_tour: {},
      change_options: {},
      change_plan: {},
      change_detail: {},

      
      delete_addon: {},
      delete_detail: {},
      delete_image: {},
      delete_plan: {},
      delete_price: {},
      delete_season: {},
      delete_variation: {},

      edit_tour: {},
      edit_options: {},
      edit_variation: {},
      edit_price: {},
      
      editaddon: {},
      edit_detail: {},
      edit_plan: {},
      editseason: {},
      upload_image: {imagename: '', imagefile: null},

      isAddAddon: false,
      isAddDetail: false,
      isAddImage: false,
      isAddPlan: false,
      isAddPrice: false,
      isAddSeason: false,
      isAddVariation: false,
      
      isDeleteAddon: false,
      isDeleteDetail: false,
      isDeleteImage: false,
      isDeletePlan: false,
      isDeletePrice: false,
      isDeleteSeason: false,
      isDeleteVariation: false,
      
      isEditAddon: false,
      isEditDetail: false,
      isEditPlan: false,
      isEditPrice: false, 
      isEditSeason: false,
      isEditVariation: false,
           
      error: undefined,
      errorindex: undefined,
      haserror: false,
      menu_seasondates: false,
    }
  },
  methods: {
    ...mapActions('Tour', 
    ['getToursRequest',
    'deleteTourVariationRequest', 'deleteTourDetailRequest', 
    'deleteTourPlanRequest', 'deleteTourPriceRequest',
    'deleteTourSeasonRequest', 'deleteTourAddonRequest',
    'insertTourVariationRequest', 'insertTourDetailRequest', 
    'insertTourPlanRequest', 'insertTourPriceRequest', 
    'insertTourSeasonRequest', 'insertTourAddonRequest', 
    'updateTourRequest','updateTourImageRequest', 'updateTourOptionsRequest',
    'updateTourVariationRequest', 'updateTourDetailRequest', 
    'updateTourPlanRequest', 'updateTourPriceRequest', 'updateTourSeasonRequest',
    'updateTourAddonRequest']),
    ...mapActions('City', ['getCitiesRequest']),
    ...mapActions('Country', ['getCountriesRequest']),
    ...mapActions("Image", ["insertRouteImage", "deleteImageRequest"]),
    ...mapActions('PriceList', ['getPriceListsRequest']),
    ...mapActions('Vendor', ['getVendorsRequest']),
    checkVariation(){
      if(this.numofvariation=='1') {this.variationtype2=null;this.variationtype3=null;this.variationtype4=null;this.variationtype5=null;}
      if(this.numofvariation=='2') {this.variationtype3=null;this.variationtype4=null;this.variationtype5=null}
      if(this.numofvariation=='3') {this.variationtype4=null;this.variationtype5=null;}
      if(this.numofvariation=='4') {this.variationtype5=null;}
    },
    checkError(){
      if(!this.numofvariation){
        this.haserrors = true;
        this.errorindex = 6;
        return false;
      }
      if((this.numofvariation=='1' || this.numofvariation=='2'|| this.numofvariation=='3') && !this.variationtype0){
        this.haserrors = true;
        this.errorindex = 7;
        return false;
      }
      if((this.numofvariation=='2' || this.numofvariation=='3') && !this.variationtype1){
        this.haserrors = true;
        this.errorindex = 8;
        return false;
      }
      if((this.numofvariation=='3') && !this.variationtype2){
        this.haserrors = true;
        this.errorindex = 9;
        return false;
      }
      if((this.variationtype0==this.variationtype1) && (this.variationtype1==this.variationtype2)){
        this.haserrors = true;
        this.errorindex = 9;
        return false;
      }
      if(this.numofvariation=='1'){this.variationtype1==null;this.variationtype2==null;this.variationtype3==null;}
      this.errorindex = -1;
      this.step = 2;
      return true;
    },

    async addTourPrice() {
      this.isAddPrice = false;
      let payload = {pricelistid: this.add_price.pricelistid, variationid: this.add_price.variationid, pricename: this.add_price.pricename };
      payload.options = this.prepareAddPrice();
      payload.tourid = this.initvalue._id;
      let result = await this.insertTourPriceRequest(payload);
      this.tourprices.push(result);
      this.arrangeTourPrices();
      this.add_price = {};
    },
    async addTourVariation() {
      this.isAddVariation = false;
      let payload = {};
      payload.options = this.parseAddVariation(this.add_variation);
      payload.tourid = this.initvalue._id;
      console.log('1',payload)
      let result = await this.insertTourVariationRequest(payload);
      console.log('2',result)
      this.tourvariations.push(result);
      this.add_variation = {};
    },
    async deleteImage(item) {
      this.isDeleteImage = false;
      let response = await this.deleteImageRequest(item);
      let index = this.images.findIndex((trans) => trans._id == response._id);
      this.images.splice(index, 1);
    },
    deleteImageDialog(item) {
      this.isDeleteImage = true;
      this.delete_image = {_id: item._id, imagename: item.imagename};
    },
    async editTourRequest() {
      this.change_tour._id = this.initvalue._id;
      await this.updateTourRequest(this.change_tour);
      router.push('/tour/list');
    },
    async editTourOptionsRequest() {
      this.change_options._id = this.initvalue._id;
      console.log(this.change_options)
      await this.updateTourOptionsRequest(this.change_options);
      router.push('/tour/list');
    },
    async editTourPriceRequest() {
      this.isEditPrice = false;
      let payload = {priceid: this.edit_price._id, pricelistid: this.edit_price.pricelistid, variationid: this.edit_price.variationid, pricename: this.edit_price.pricename };
      payload.options = this.prepareEditPrice();
      let response = await this.updateTourPriceRequest(payload);
      let index = this.tourprices.findIndex((price) => price._id == response._id);
      this.tourprices.splice(index, 1, response);
      this.arrangeTourPrices();
    },
    async editTourVariation() {
      this.isEditVariation=false;
      let payload = {};
      payload.options = this.parseEditVariation(this.edit_variation);
      payload.variationid = this.edit_variation._id;
      let response = await this.updateTourVariationRequest(payload);
      let index = this.tourvariations.findIndex((variation) => variation._id == response._id);
      this.tourvariations.splice(index, 1, response);
    },
    editTourPriceDialog(item) {
      this.edit_price = {};
      this.edit_price = Object.assign({}, item);
      this.parseEditPrice(item.options);
      this.edit_numofprices = [];
      for(let i in item.options) this.edit_numofprices.push(parseInt(i)+1);
      this.isEditPrice = true;
    },
    editTourVariationDialog(item) {
      this.isEditVariation = true;
      this.edit_variation = Object.assign(item);
      for(let i=1; i<=5; i++){
        if(item.options.find(option=>option.index==i)!=null) {
          this.edit_variation['index' + i.toString()] = i;
          this.edit_variation['variationtype' + i.toString()]=item.options.find(option=>option.index==i).value;
          this.edit_variation['variationdesc' + i.toString()]=item.options.find(option=>option.index==i).desc;
        }
      }


      // if(item.options.find(option=>option.index==1)!=null) {
      //   this.edit_variation.index1 = 1;
      //   this.edit_variation['variationtype1']=item.options.find(option=>option.index==1).value;
      // }
      // if(item.options.find(option=>option.index==2)!=null) {
      //   this.edit_variation.index2 = 2;
      //   this.edit_variation['variationtype2']=item.options.find(option=>option.index==2).value;
      // }
      // if(item.options.find(option=>option.index==3)!=null) {
      //   this.edit_variation.index3 = 3;
      //   this.edit_variation['variationtype3']=item.options.find(option=>option.index==3).value;
      // }
      // if(item.options.find(option=>option.index==4)!=null) {
      //   this.edit_variation.index4 = 4;
      //   this.edit_variation['variationtype4']=item.options.find(option=>option.index==4).value;
      // }
      // if(item.options.find(option=>option.index==5)!=null) {
      //   this.edit_variation.index3 = 5;
      //   this.edit_variation['variationtype5']=item.options.find(option=>option.index==5).value;
      // }
    },









    async addTourAddon() {
      this.isAddAddon = false;
      this.addon.tourid = this.initvalue._id;
      this.addon.variations = this.addon.variations.map(variation=>variation.value);
      let result = await this.insertTourAddonRequest(this.addon);
      this.touraddons.push(result);
      this.addon = {options:{}};
    },
    async addTourDetail() {
      this.isAddDetail = false;
      this.add_detail.tourid = this.initvalue._id;
      let result = await this.insertTourDetailRequest(this.add_detail);
      this.tourdetails.push(result);
      this.add_detail = {};
    },
    async addTourPlan() {
      this.isAddPlan = false;
      this.add_plan.tourid = this.initvalue._id;
      let result = await this.insertTourPlanRequest(this.add_plan);
      this.tourplans.push(result);
      this.add_plan = {};
    },
    async addTourSeason() {
      this.isAddSeason = false;
      this.season.tourid = this.initvalue._id;
      if(this.season.seasontype=='Dates')this.season.seasondays=this.season.seasondates;
      this.season.variations = this.season.variations.map(variation=>variation.value);
      let result = await this.insertTourSeasonRequest(this.season);
      this.tourseasons.push(result);
      this.season = {surcharge:{}, seasondates:[]};
    },
    deletePriceOption(index){
      this.edit_numofprices.splice(index,1);
      this.edit_price.options.splice(index,1);
    },
    deleteTourVariationDialog(item) {
      this.isDeleteVariation = true;
      this.delete_variation = {_id: item._id,variationname: item.options.map(option=>option.value).join(' - '),};
    },
    deleteTourDetailDialog(item) {
      this.isDeleteDetail = true;
      this.delete_detail = {_id: item._id, detailtitle: item.detailtitle};
    },
    deleteTourPlanDialog(item) {
      this.isDeletePlan = true;
      this.delete_plan = {_id: item._id,plantitle: item.plantitle};
    },
    deleteTourAddonDialog(item) {
      this.isDeleteAddon = true;
      this.delete_addon = {_id: item._id,addonname: item.addonname};
    },
    deleteTourSeasonDialog(item) {
      this.isDeleteSeason = true;
      this.delete_season = {_id: item._id,seasonname: item.seasonname};
    },
    deleteTourPriceDialog(item) {
      this.isDeletePrice = true;
      this.delete_price = {_id: item._id,pricename: item.pricename,variationid: item.variationid};
    },
    async deleteTourPrice(payload) {
      this.isDeletePrice = false;
      let response = await this.deleteTourPriceRequest(payload);
      let index = this.tourprices.findIndex((price) => price._id == response._id);
      this.tourprices.splice(index, 1);
      this.arrangeTourPrices();
    },
    async deleteTourVariation(payload) {
      this.isDeleteVariation = false;
      let response = await this.deleteTourVariationRequest(payload);
      let index = this.tourvariations.findIndex((variation) => variation._id == response._id);
      this.tourvariations.splice(index, 1);
    },
    async deleteTourDetail(payload) {
      this.isDeleteDetail = false;
      let response = await this.deleteTourDetailRequest(payload);
      let index = this.tourdetails.findIndex((trans) => trans._id == response._id);
      this.tourdetails.splice(index, 1);
    },
    async deleteTourPlan(payload) {
      this.isDeletePlan = false;
      let response = await this.deleteTourPlanRequest(payload);
      let index = this.tourplans.findIndex((trans) => trans._id == response._id);
      this.tourplans.splice(index, 1);
    },
    async deleteTourSeason(payload) {
      this.isDeleteSeason = false;
      let response = await this.deleteTourSeasonRequest(payload);
      let index = this.tourseasons.findIndex((trans) => trans._id == response._id);
      this.tourseasons.splice(index, 1);
    },
    async deleteTourAddon(payload) {
      this.isDeleteAddon = false;
      let response = await this.deleteTourAddonRequest(payload);
      let index = this.touraddons.findIndex((trans) => trans._id == response._id);
      this.touraddons.splice(index, 1);
    },
    editTourDetailDialog(item) {
      this.edit_detail = {};
      this.change_detail = {};
      this.isEditDetail = true;
      this.edit_detail = Object.assign({}, item);
    },
    
    editTourPlanDialog(item) {
      this.edit_plan = {};
      this.change_plan = {};
      this.isEditPlan = true;
      this.edit_plan = Object.assign({}, item);
    },
    editTourSeasonDialog(item) {
      this.season = {};
      this.isEditSeason = true;
      this.editseason = Object.assign({}, item);
      this.season = this.editseason;
      this.season.seasonid = this.season._id;
      delete this.season['createdAt'];
      delete this.season['updatedAt'];
      delete this.season['userid'];
      delete this.season['_id'];
      delete this.season['__v'];
      this.season.variations = this.season.variations.map((vid)=>{
        let result = this.tourvariations.find(variation=>variation._id==vid);
        return {text: result.options.map(option=>option.value).join('-'), value: result._id}
      });
      if(this.season.seasontype=='Dates')this.season.seasondates=this.season.seasondays;
    },
    editTourAddonDialog(item) {
      this.addon = {};
      this.isEditAddon = true;
      this.editaddon = Object.assign({}, item);
      this.addon = this.editaddon;
      this.addon.addonid = this.addon._id;
      delete this.addon['createdAt'];
      delete this.addon['updatedAt'];
      delete this.addon['userid'];
      delete this.addon['_id'];
      delete this.addon['__v'];
      this.addon.variations = this.addon.variations.map((vid)=>{
        let result = this.tourvariations.find(variation=>variation._id==vid);
        return {text: result.options.map(option=>option.value).join('-'), value: result._id}
      });
    },

    async editTourDetail() {
      this.isEditDetail = false;
      this.change_detail.tourdetailid = this.edit_detail._id;
      let response = await this.updateTourDetailRequest(this.change_detail);
      let index = this.tourdetails.findIndex((i) => i._id == response._id);
      this.tourdetails.splice(index, 1, response);
    },
    editTourPhotoRequest() {
      this.change_photo._id = this.initvalue._id;
      this.updateTourImageRequest(this.change_photo);
      this.getToursRequest();
      router.push('/tour/list');
    },
    async editTourPlan() {
      this.isEditPlan = false;
      this.change_plan.tourplanid = this.edit_plan._id;
      let response = await this.updateTourPlanRequest(this.change_plan);
      let index = this.tourplans.findIndex((plan) => plan._id == response._id);
      this.tourplans.splice(index, 1, response);
    },
    async editTourSeason() {
      this.isEditSeason = false;
      if(this.season.seasontype=='Dates')this.season.seasondays=this.season.seasondates;
      this.season.variations = this.season.variations.map(variation=>variation.value);
      let response = await this.updateTourSeasonRequest(this.season);
      let index = this.tourseasons.findIndex((season) => season._id == response._id);
      this.tourseasons.splice(index, 1, response);
    },
    async editTourAddon() {
      this.isEditAddon = false;
      this.addon.variations = this.addon.variations.map(variation=>variation.value);
      console.log(this.addon);
      let response = await this.updateTourAddonRequest(this.addon);
      let index = this.touraddons.findIndex((addon) => addon._id == response._id);
      this.touraddons.splice(index, 1, response);
    },
    getVariationsList(){
      if(this.tourvariations==null) return [];
      let list = this.tourvariations.map(variation=>{return{text: variation.options.map(option=>option.value).join('-'), value: variation._id}});
      return list;
    },
    getAddonsList(){
      return [];
      //let list = this.touraddons.map(addon=>{return{text: addon.addonname, value: addon._id}});
      //return list;
    },
    getVariationsText(variationid){
      let variation = this.tourvariations.find(variation=>variation._id==variationid);
      let text;
      if(variation!=null) text = variation.options.map(option=>option.value).join('-');
      return text;
    },
    getAddonText(addonid){
      let addon = this.touraddons.find(addon=>addon._id==addonid);
      let text;
      if(addon!=null) text = addon.addonname;
      return text;
    },
    getPriceOptions(options){
      let result = options.map(option=>option.class + ' (' +option.minpax + '-' +option.maxpax + 'pax): ' + option.listprice + " " + option.currency);
      return result;
    },
    getVariationOptions(variationid){
      let variation = this.tourvariations.find(variation=>variation._id==variationid);
      let list = variation!=null ? variation.options.map(option=>option.value) : [];
      return list.join('-');
    },


    parseAddVariation(variations){
        let result = [];
        console.log('v', variations)
        for (let x in variations) {
          if(x.includes("index")){
            let i = parseInt(x.split("index")[1]);
            if(this.initvalue.options['variationtype' + i]!=null && this.initvalue.options['variationtype' + i]!=''){
              result.push({
                index: i,
                type: this.initvalue.options['variationtype' + i],
                value: this.add_variation['variationtype' + i],
                desc: this.add_variation['variationdesc' + i]
              });
            }
          }            
        }
        return result;
    },
    parseEditVariation(variations){
        let result = [];
        for (let x in variations) {
          if(x.includes("index")){
            let i = parseInt(x.split("index")[1]);
            if(this.initvalue.options['variationtype' + i]!=null && this.initvalue.options['variationtype' + i]!=''){
              result.push({
                index: i,
                type: this.initvalue.options['variationtype' + i],
                value: this.edit_variation['variationtype' + i],
                desc: this.edit_variation['variationdesc' + i]
              });
            }
          }            
        }
        return result;
    },
    prepareAddPrice(){
        let result = [];
        for (let i in this.add_numofprices) {
          result.push({
            class: this.add_price['class' + this.add_numofprices[i]],
            subclass: this.add_price['subclass' + this.add_numofprices[i]],
            desc: this.add_price['desc' + this.add_numofprices[i]],
            listprice: this.add_price['listprice' + this.add_numofprices[i]],
            minpax: this.add_price['minpax' + this.add_numofprices[i]],
            maxpax: this.add_price['maxpax' + this.add_numofprices[i]],
            currency: this.add_price['currency' + this.add_numofprices[i]],
          });           
        }
        return result;
    },
    prepareEditPrice(){
        let result = [];
        for (let i in this.edit_numofprices) {
          result.push({
            class: this.edit_price['class' + this.edit_numofprices[i]],
            subclass: this.edit_price['subclass' + this.edit_numofprices[i]],
            desc: this.edit_price['desc' + this.edit_numofprices[i]],
            listprice: this.edit_price['listprice' + this.edit_numofprices[i]],
            minpax: this.edit_price['minpax' + this.edit_numofprices[i]],
            maxpax: this.edit_price['maxpax' + this.edit_numofprices[i]],
            currency: this.edit_price['currency' + this.edit_numofprices[i]],
          });           
        }
        return result;
    },
    parseEditPrice(options){
      for(let i in options){
        let option = JSON.parse(JSON.stringify(options[i]));
        this.edit_price['class'+ (parseInt(i)+1)] = option.class??'';
        this.edit_price['subclass'+ (parseInt(i)+1)] = option.subclass??'';
        this.edit_price['desc'+ (parseInt(i)+1)] = option.desc??'';
        this.edit_price['listprice'+ (parseInt(i)+1)] = parseFloat(option.listprice);
        this.edit_price['minpax'+ (parseInt(i)+1)] = parseInt(option.minpax);
        this.edit_price['maxpax'+ (parseInt(i)+1)] = parseInt(option.maxpax);
        this.edit_price['currency'+ (parseInt(i)+1)] = option.currency??'';
      }
    },
    onChangeAddPlanFile(file) {
      if (!file) {return;}
      this.add_plan.imagefile = file;
      this.add_plan.imagename = file.name;
    },
    onChangeEditPlanFile(file) {
      if (!file) {return;}
      this.edit_plan.imagefile = file;
      this.edit_plan.imagename = file.name;
    },
    onChangeTour(value, field){
      this.change_tour[field] = value;
    },
    onChangeOptions(value, field){
      if(field.includes('variationtype')){
        for (let i=1 ; i<=5; i++) {
          if(i<=this.numofvariation) this.change_options['variationtype'+i.toString()] = this.edit_options['variationtype'+i.toString()];
          else if(i>this.numofvariation) this.change_options['variationtype'+i.toString()] = null;
        }
      }
      this.change_options[field] = value;
    },
    onChangePhoto(file) {
      if (!file) {return;}
      this.change_photo.imagefile = file;
      this.change_photo.imagename = file.name;
      this.createImage(file);
    },
    onImageChange(image) {
      if (!image) this.upload_image.image = null;
      else this.upload_image.image = image;
    },

    onChangeDetail(value, field){
      this.change_detail[field] = value;
    },
    onChangePlan(value, field){
      this.change_plan[field] = value;
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => {this.imageurl = e.target.result};
      reader.readAsDataURL(file);
    },


    onUploadChange(file) {
      if (!file) {return;}
      this.upload_image.tourimage = file;
      this.upload_image.imagename = file.name;
    },
    async uploadImage(){
      this.upload_image.id = this.initvalue._id;
      this.upload_image.route = 'tour';
      this.isAddImage = false;
      let image = await this.insertRouteImage(this.upload_image);
      this.images.push(image);
    },
    arrangeTourPrices(){
      for(var i in this.tourprices){
        let price = this.tourprices[i];
        price['adult_options'] = price.options.filter(i=>i.class=='Adult');
        price['youth_options'] = price.options.filter(i=>i.class=='Youth');
        price['child_options'] = price.options.filter(i=>i.class=='Child');
        price['infant_options'] = price.options.filter(i=>i.class=='Infant');
      }
    }
  },
  computed: {
    ...mapState('Tour', ['isReceiving']),
    ...mapState('City', ['cities']),
    ...mapState('Country', ['countries']),
    ...mapState('PriceList', ['pricelists']),
    ...mapState('Vendor', ['vendors']),
  },
  created () {
    this.initvalue = this.$route.params;
    this.edit_tour = Object.assign({}, this.initvalue);
    console.log(this.initvalue)

    this.edit_options = Object.assign({}, this.initvalue.options);

    if(this.initvalue.options!=null){
      this.numofvariation = this.initvalue.options.numofvariations;
      this.variationtype0 = this.initvalue.options.variationtype0;
      this.variationtype1 = this.initvalue.options.variationtype1;
      this.variationtype2 = this.initvalue.options.variationtype2;
      this.variationtype3 = this.initvalue.options.variationtype3;
      this.variationtype4 = this.initvalue.options.variationtype4;
      this.variationtype5 = this.initvalue.options.variationtype5;
      if(this.variationtype4 && (this.numofvariation==4 || this.numofvariation==5)) this.variationHeaders.unshift({ text: this.variationtype4, value: "options4" });
      if(this.variationtype3 && (this.numofvariation==3 || this.numofvariation==4 || this.numofvariation==5)) this.variationHeaders.unshift({ text: this.variationtype3, value: "options3" });
      if(this.variationtype2 && (this.numofvariation==2 || this.numofvariation==3 || this.numofvariation==4 || this.numofvariation==5)) this.variationHeaders.unshift({ text: this.variationtype2, value: "options2" }); 
      if(this.variationtype1 && (this.numofvariation==1 || this.numofvariation==2 || this.numofvariation==3 || this.numofvariation==4 || this.numofvariation==5)) this.variationHeaders.unshift({ text: this.variationtype1, value: "options1" }); 
    }
    if(!this.initvalue._id) this.$router.push({ name: 'TourList' });
    this.imageurl = this.initvalue.tourimage;
    this.images = this.initvalue.images;
    
    this.touraddons = this.initvalue.addons;
    this.tourdetails = this.initvalue.details;
    this.tourplans = this.initvalue.plans;
    this.tourprices = this.initvalue.prices;
    this.tourseasons = this.initvalue.seasons;
    this.tourvariations = this.initvalue.variations;
    this.arrangeTourPrices();
    //console.log('here', this.tourprices)

    console.log('here', this.tourprices)

    if(this.cities.length==0) this.getCitiesRequest();
    if(this.countries.length==0) this.getCountriesRequest();
    if(this.vendors.length==0) this.getVendorsRequest();
    if(this.pricelists.length==0) this.getPriceListsRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
